import { CollectionInterface } from '../../../interfaces/collection.interface';

export class LoadCollectionsSuccess {
    public static readonly type = '[JobsPlacements] Load collections success';

    constructor(public collections: Array<CollectionInterface>) { }
}
